import { Model } from '@/models/Model';
import { User } from '@/models/User';

export class LeadFile extends Model {
  protected $name: string = 'LeadFile';
  protected $endpoint: string = '/leads/{id}/relationships/files';
  protected $fillable: string[] = ['file', 'name', 'meta'];

  public id?: string;
  public file?: File;
  public name?: string;
  public mime_type?: string;
  public meta?: Meta;
  public links?: any;

  public user(user: User | string) {
    if (typeof user !== 'string') {
      user = user.id || '';
    }
    this.$endpoint = `/leads/${user}/relationships/files`;

    return this;
  }

  public setIdAttribute(id: string) {
    this.$endpoint = `/leads/${this.user}/relationships/files`;

    return id;
  }

  deleteUserFile(userId: string, id: string) {
    const url = `/leads/${userId}/relationships/files/${id}`;
    return this.request('delete', url);
  }
}

interface Meta {
  subject: string;
}
